import { Controller, RegisterOptions, UseFormMethods } from 'react-hook-form';
import PhoneNumberInput, { Props as PhoneNumberInputProps } from './PhoneNumberInput';

type Props = {
    form: UseFormMethods<any>;
    name: string;
    rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & Omit<PhoneNumberInputProps, 'value' | 'onChange'>;

const PhoneNumberInputController = ({ form, name, rules, ...props }: Props) => {
    // Default validation: if phone number is entered, it must have a country code (starts with +)
    const defaultValidate = (value: string) => {
        if (!value) return true; // Empty is OK (optional field)
        if (value.startsWith('+')) return true; // Has dial code
        return false; // Missing dial code - will show generic "required" message
    };

    // Merge default validation with any custom rules
    const mergedRules: RegisterOptions = {
        ...rules,
        validate: {
            phoneCountryCode: defaultValidate,
            ...(typeof rules?.validate === 'function'
                ? { custom: rules.validate }
                : rules?.validate)
        }
    };

    return (
        <Controller
            render={({ onChange, value }) => {
                return (
                    <PhoneNumberInput
                        {...props}
                        value={value || ''}
                        onChange={fullPhoneNumber => {
                            onChange(fullPhoneNumber);
                        }}
                    />
                );
            }}
            control={form.control}
            name={name}
            defaultValue={form.getValues(name) || ''}
            rules={mergedRules}
        />
    );
};

export default PhoneNumberInputController;
